import {Injectable} from '@angular/core';
import {Overlay} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {TreeDialogComponent} from '../tree-dialog.component';

@Injectable()
export class TreeDialogService {
  constructor(private overlay: Overlay) {

  }

  open(top: string, left: string) {
    const positionStrategy = this.overlay.position().global()
      .top(top)
      .left(left);

    const overlayRef = this.overlay.create({
      positionStrategy: positionStrategy,
      panelClass: 'tree-dialog-panel',
      backdropClass: ['cdk-overlay-backdrop', 'cdk-overlay-transparent-backdrop', 'cdk-overlay-backdrop-showing'],
      scrollStrategy: this.overlay.scrollStrategies.block(),
      hasBackdrop: true,
    });
    const treeComponent = new ComponentPortal(TreeDialogComponent);
    overlayRef.attach(treeComponent);

    overlayRef.backdropClick().subscribe(re => {
      overlayRef.dispose();
    });

  }
}
